import {initializeApp, getApps} from 'firebase/app';
import {
  getMessaging,
  getToken,
  isSupported,
  type Messaging,
} from 'firebase/messaging';
import axios from 'axios';

/** Named app so this module can coexist with nudge notifications FCM (`notifications/fcm-init`). */
const CRM_TRM_FIREBASE_APP_NAME = 'crm-trm';

const crmTrmFirebaseConfig = {
  // Project Settings => Add Firebase to your web app
  apiKey: 'AIzaSyB5aWatGA_TweeGTh12WTrknFl9rUn-L3o',
  authDomain: 'skillate-test-f32e0.firebaseapp.com',
  databaseURL: 'https://skillate-test-f32e0.firebaseio.com',
  projectId: 'skillate-test-f32e0',
  storageBucket: 'skillate-test-f32e0.appspot.com',
  messagingSenderId: '443261155653',
  appId: '1:443261155653:web:94a68f62b6c28933fc262c',
  measurementId: 'G-3CEEHBVD80',
};

const initializedFirebaseApp =
  getApps().find((a) => a.name === CRM_TRM_FIREBASE_APP_NAME) ??
  initializeApp(crmTrmFirebaseConfig, CRM_TRM_FIREBASE_APP_NAME);

// Declare messaging variable
export let messaging: Messaging | null = null;

// Handle permissions and messaging token
const onPermissionChange = async (messagingInstance: Messaging) => {
  if ('permissions' in navigator) {
    navigator.permissions
      .query({name: 'notifications'})
      .then((notificationPerm) => {
        notificationPerm.onchange = async () => {
          if (notificationPerm.state === 'granted') {
            await getToken(messagingInstance).then((token) => {
              axios.post(
                `/trmapi/api/notification-token-for-user?token=${token}&isActive=true`,
              );
            });
          } else if (notificationPerm.state === 'denied') {
            axios.post(
              `/trmapi/api/notification-token-for-user?token=&isActive=false`,
            );
          }
        };
      });
  }
};

export const getPermission = async () => {
  const supported = await isSupported();
  if (!supported) {
    return;
  }

  messaging = getMessaging(initializedFirebaseApp);
  if (!messaging) {
    return;
  }

  const messagingInstance = messaging; // Capture in a const to help TypeScript narrow the type

  // Request permission for push notifications
  Notification.requestPermission()
    .then(async (permission) => {
      if (permission === 'granted') {
        await getToken(messagingInstance).then((token) => {
          axios.post(
            `/trmapi/api/notification-token-for-user?token=${token}&isActive=true`,
          );
        });
      } else {
        axios.post(
          `/trmapi/api/notification-token-for-user?token=&isActive=false`,
        );
      }

      onPermissionChange(messagingInstance);
    })
    .catch((_err) => {
      axios.post(
        `/trmapi/api/notification-token-for-user?token=&isActive=false`,
      );
      onPermissionChange(messagingInstance);
    });

  // Listen for messages from the service worker
  navigator.serviceWorker.addEventListener('message', (res) => {
    const {data} = res;

    // Ignore non-Firebase messages (e.g., from MSW or other service workers)
    if (!data || !data['firebase-messaging-msg-data']) {
      return;
    }
    const title = data['firebase-messaging-msg-data'].data.title;
    const options = {
      body: data['firebase-messaging-msg-data'].data.body,
      icon: data['firebase-messaging-msg-data'].data.icon,
      tag: data['firebase-messaging-msg-data'].data.notificationMessageId,
    };

    const notify = new Notification(title, options);
    notify.onclick = () => {
      notify.close();
      axios.get(
        `/trmapi/api/notifications-clicked/${data['firebase-messaging-msg-data'].data.notificationMessageId}`,
      );
      window.open(data['firebase-messaging-msg-data'].data.link);
    };
  });
};
